import { render, staticRenderFns } from "./TodoFilterCards.vue?vue&type=template&id=6431dfea&scoped=true&"
import script from "./TodoFilterCards.vue?vue&type=script&lang=js&"
export * from "./TodoFilterCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6431dfea",
  null
  
)

export default component.exports